/* Presentation only: preserve the original elements and their action handlers. */
(function () {
  'use strict';
  if (window.ptPdpAccentLinksBound) return;
  window.ptPdpAccentLinksBound = true;
  var selector = '.pt-style-explore-link, .pt-size-guide-link, .pt-shipping-estimate__need-sooner-trigger, .pt-shipping-estimate__more-styles, .small-feature-link, .pt-matching-fabric-link a, .matching-builder__customise-cta-line1, .fabric-builder__customise-cta-line1, .solo-options__customise-cta-line1';
  function refresh() {
    document.querySelectorAll('.product-info').forEach(function (root) {
      var labels = Array.from(root.querySelectorAll(selector));
      // Some benefit blocks supply their Details link through merchant/app markup.
      root.querySelectorAll('a, button').forEach(function (link) {
        if (/^details\s*[→]?$/i.test(link.textContent.trim())) labels.push(link);
      });
      labels.forEach(function (label) {
        // Do not flatten icons, prices, or other structured control content.
        if (label.children.length) return;
        var text = label.textContent.trim().replace(/\s*(?:→|&rarr;)\s*$/, '').trim();
        if (!text) return;
        text = text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() + ' →';
        label.classList.add('pt-pdp-accent-link');
        if (label.textContent !== text) label.textContent = text;
      });
    });
  }
  refresh();
  // Builders and variant/section updates replace the visible labels.
  new MutationObserver(function (records) {
    if (records.some(function (record) {
      var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      return target && (target.closest('.product-info') || Array.from(record.addedNodes).some(function (node) {
        return node.nodeType === 1 && (node.matches('.product-info') || node.querySelector('.product-info'));
      }));
    })) refresh();
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
